export const PTInputMask = {
  root: {
    className: '',
  },
};
